import { render, staticRenderFns } from "./SectionsCardB.vue?vue&type=template&id=5e53716f"
import script from "./SectionsCardB.vue?vue&type=script&lang=js"
export * from "./SectionsCardB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports